<template>
  <div
    class="container container-main py-2 md:py-[16px] bg-white z-10"
    :class="{
      'header-shadow': isOpenMenu,
    }"
  >
    <div class="flex items-center flex-col">
      <div class="flex w-full items-center xl:gap-[26px]">
        <button
          v-if="!isOpenMenu"
          type="button"
          class="w-[32px] h-[32px] md:w-[44px] md:h-[44px] overflow-hidden xl:hidden justify-center"
          @click="$emit('toogle-menu')"
        >
          <icon-burger-menu class="text-[#052F41]" />
        </button>
        <button
          v-else
          type="button"
          class="flex items-center justify-center md:p-0 gap-2 uppercase w-[32px] h-[32px] md:w-[44px] md:h-[44px] text-primaryrounded-[5px] overflow-hidden xl:hidden"
          @click="$emit('toogle-menu')"
        >
          <icon-close class="text-[#052F41]" />
        </button>
        <div v-if="!isInFrame()" class="mx-auto ml-[12px] lg:ml-auto xl:mr-0 xl:mx-0 xl:shrink-0">
          <figure class="flex items-center gap-2 flex-wrap">
            <router-link :to="{ name: '/home' }" @click="$emit('close-mobile-menu')">
              <img loading="lazy" src="/img/logo/logo-kids.svg" alt="logo"
                class="w-[72px] md:w-[92px] xl:w-[180px] xl:block hidden" />
              <img loading="lazy" src="/img/logo/logo-kids-mobile.svg" alt="logo-mobile"
                class="min-[350px]:w-[180px] w-[121px] xl:hidden block" />
            </router-link>
            <!-- hide doublicated logotypes
            <a href="https://kidpreneurs.academy/" target="_blank" rel="noopener noreferrer">
              <img loading="lazy" src="/img/logo/logo-kids-academy.svg" alt="store logo"
                class="w-[72px] md:w-[92px] xl:w-[170px] xl:block hidden" />
              <img loading="lazy" src="/img/logo/logo-kids-mobile-academy.svg" alt="store logo mobile"
                class="min-[350px]:w-[230px] w-[121px] xl:hidden block" />
            </a> -->
          </figure>
        </div>
        <div class="flex md:hidden"></div>
        <div
          class="xl:flex-col gap-4 xl:w-full xl:flex relative"
          :class="isInFrame() && ['!flex-row-reverse']"
        >
          <HeaderNavKids @open-partner-form="(type) => $emit('open-partner-form', type)" />
          <div class="gap-6 hidden xl:flex mb-4 z-20">
            <!-- <HeaderCategoriesKids /> -->
            <ProductSearchKids
              v-if="!isInFrame()"
              class="hidden items-center gap-2 xl:w-full xl:flex w-full"
            />
          </div>
        </div>
      </div>
      <ProductSearchKids
        v-if="!isOpenMenu && !isInFrame()"
        class="relative w-full md:py-[3px] flex xl:hidden mt-4"
        is-mobile
      />
    </div>
  </div>
</template>

<script setup>
import { isInFrame } from "@academy/utils"

import HeaderNavKids from "./header-nav/HeaderNavKids.vue"
// import HeaderCategoriesKids from "./header-categories/HeaderCategoriesKids.vue"
import ProductSearchKids from "@/components/header/product-search-list/ProductSearchKids.vue"
import IconClose from "@/components/icons/IconClose.vue"
import IconBurgerMenu from "@/components/icons/IconBurgerMenu.vue"

defineProps({
  isOpenMenu: {
    type: Boolean,
    required: true,
  },
  isMobileSearch: {
    type: Boolean,
    required: true,
  },
})

defineEmits({
  "toogle-menu": null,
  "toogle-mobile-search": null,
  "close-mobile-menu": null,
  "open-partner-form": null,
  search: (value) => typeof value === "string",
})
</script>

<style lang="scss" scoped>
.sticky {
  position: relative;
  @media (max-width: 768px) {
    @apply fixed;
  }
}

.header-shadow {
  @media (max-width: 768px) {
    @apply shadow-[0_4px_4px_rgba(0,0,0,0.05)];
  }
}
</style>
